if (!customElements.get("m-vehicle-finder")) {
  const SVG = {
    tuning:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2 4 14h6l-1 8 9-12h-6l1-8Z"/></svg>',
    diag:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12h4l2 5 4-12 2 7h6"/></svg>',
    slr:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 14 16 9"/><path d="M4.5 18a9 9 0 1 1 15 0"/><circle cx="12" cy="14" r="1.4" fill="currentColor" stroke="none"/></svg>',
    module:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="7" y="7" width="10" height="10" rx="1.5"/><path d="M10 3v2M14 3v2M10 19v2M14 19v2M3 10h2M3 14h2M19 10h2M19 14h2"/></svg>',
  };

  class MVehicleFinder extends HTMLElement {
    connectedCallback() {
      this.data = (window.MJET_VF && window.MJET_VF.records) || [];
      this.brandOrder = (window.MJET_VF && window.MJET_VF.brandOrder) || [];
      // Modellnamen mit englischer Variante (z. B. Außenborder -> Outboard)
      this.isEn = (document.documentElement.lang || "").toLowerCase().startsWith("en");
      const d = this.dataset;
      this.urls = {
        tuning: d.configUrl || "/products/m-jet-flasher-fur-sea-doo-rotax-jps",
        tuningCanam: d.canamUrl || "/products/m-jet-flasher-fur-can-am",
        tuningSnow: d.snowUrl || "/products/m-jet-flasher-fur-ski-doo-lynx",
        diag: d.diagUrl || "/products/m-jet-diagnostic-brp-diagnose-tool",
        diagYamaha: d.diagYamahaUrl || "/products/m-jet-diagnostic-yamaha",
        slr: d.slrUrl || "/products/m-jet-vmax-remover-gps-lost-fur-seadoo-325er",
        module: d.moduleUrl || "/collections/m-jet-module",
      };
      this.t = {
        year: d.tYear || "Jahr",
        brand: d.tBrand || "Marke",
        model: d.tModel || "Modell",
        forLabel: d.tFor || "Für dein",
        tuningT: d.catTuningT || "Tuning",
        tuningD: d.catTuningD || "",
        diagT: d.catDiagT || "Diagnose",
        diagD: d.catDiagD || "",
        slrT: d.catSlrT || "Speed Limit Remover",
        slrD: d.catSlrD || "",
        moduleT: d.catModuleT || "Module",
        moduleD: d.catModuleD || "",
      };

      this.yearSel = this.querySelector("[data-vf-year]");
      this.brandSel = this.querySelector("[data-vf-brand]");
      this.modelSel = this.querySelector("[data-vf-model]");
      this.result = this.querySelector("[data-vf-result]");

      this._fillYears();
      this.yearSel.addEventListener("change", () => this._onYear());
      this.brandSel.addEventListener("change", () => this._onBrand());
      this.modelSel.addEventListener("change", () => this._onModel());
    }

    _opt(sel, value, label, selected) {
      const o = document.createElement("option");
      o.value = value;
      o.textContent = label;
      if (selected) o.selected = true;
      sel.appendChild(o);
    }

    _reset(sel, placeholder) {
      sel.innerHTML = "";
      this._opt(sel, "", placeholder, true);
      sel.disabled = true;
      sel.classList.remove("is-filled");
    }

    _fillYears() {
      const years = Array.from(new Set(this.data.map((r) => r.y))).sort((a, b) => b - a);
      this._reset(this.yearSel, this.t.year);
      this.yearSel.disabled = false;
      years.forEach((y) => this._opt(this.yearSel, String(y), String(y)));
    }

    _onYear() {
      this._reset(this.brandSel, this.t.brand);
      this._reset(this.modelSel, this.t.model);
      this._hideResult();
      this.yearSel.classList.toggle("is-filled", !!this.yearSel.value);
      const y = parseInt(this.yearSel.value, 10);
      if (!y) return;
      let brands = Array.from(new Set(this.data.filter((r) => r.y === y).map((r) => r.b)));
      brands.sort((a, b) => {
        const ia = this.brandOrder.indexOf(a), ib = this.brandOrder.indexOf(b);
        return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib) || a.localeCompare(b);
      });
      this.brandSel.disabled = false;
      brands.forEach((b) => this._opt(this.brandSel, b, b));
    }

    _onBrand() {
      this._reset(this.modelSel, this.t.model);
      this._hideResult();
      this.brandSel.classList.toggle("is-filled", !!this.brandSel.value);
      const y = parseInt(this.yearSel.value, 10);
      const b = this.brandSel.value;
      if (!y || !b) return;
      const models = this.data
        .filter((r) => r.y === y && r.b === b)
        .sort((a, b) => a.m.localeCompare(b.m, undefined, { numeric: true }));
      this.modelSel.disabled = false;
      models.forEach((r) => this._opt(this.modelSel, r.m, this._label(r)));
    }

    _onModel() {
      this.modelSel.classList.toggle("is-filled", !!this.modelSel.value);
      const y = parseInt(this.yearSel.value, 10);
      const b = this.brandSel.value;
      const m = this.modelSel.value;
      if (!y || !b || !m) return this._hideResult();
      const rec = this.data.find((r) => r.y === y && r.b === b && r.m === m);
      if (!rec) return this._hideResult();
      this._showResult(y, b, this._label(rec), rec.g);
    }

    _label(r) {
      // Yamaha-Außenborder: Bezeichnung aus der Sprachdatei (alle Shop-Sprachen)
      if (r.g === "yamaha_om" && this.dataset.tOutboard) return this.dataset.tOutboard;
      return this.isEn && r.mEn ? r.mEn : r.m;
    }

    _hideResult() {
      if (this.result) {
        this.result.hidden = true;
        this.result.innerHTML = "";
      }
    }

    _cats(group, brand) {
      // Yamaha (WaveRunner und Außenborder): bisher nur Diagnose, kein Tuning
      if (brand === "Yamaha") {
        return [{ k: "diag", icon: SVG.diag, t: this.t.diagT, d: this.t.diagD, href: this.urls.diagYamaha, primary: true }];
      }
      const isBoat = group === "jetboot";
      const isCanam = brand === "Can-Am";
      const isSnow = brand === "Ski-Doo" || brand === "Lynx";
      const isSeaDooPwc = brand === "Sea-Doo" && !isBoat;
      const tuningBase = isSnow ? this.urls.tuningSnow : isCanam ? this.urls.tuningCanam : this.urls.tuning;
      const list = [
        { k: "tuning", icon: SVG.tuning, t: this.t.tuningT, d: this.t.tuningD, href: tuningBase + "?group=" + encodeURIComponent(group), primary: true },
      ];
      if (!isCanam && !isSnow && group === "new_325") {
        list.push({ k: "slr", icon: SVG.slr, t: this.t.slrT, d: this.t.slrD, href: this.urls.slr });
      }
      if (isSeaDooPwc) {
        list.push({ k: "module", icon: SVG.module, t: this.t.moduleT, d: this.t.moduleD, href: this.urls.module });
      }
      list.push({ k: "diag", icon: SVG.diag, t: this.t.diagT, d: this.t.diagD, href: this.urls.diag });
      return list;
    }

    _showResult(y, b, m, group) {
      const cats = this._cats(group, b);
      const cards = cats
        .map(
          (c) =>
            '<a class="m-vf__cat' + (c.primary ? " is-primary" : "") + '" href="' + c.href + '">' +
            '<span class="m-vf__cat-ic" aria-hidden="true">' + c.icon + "</span>" +
            '<span class="m-vf__cat-body"><span class="m-vf__cat-t">' + this._esc(c.t) + "</span>" +
            (c.d ? '<span class="m-vf__cat-d">' + this._esc(c.d) + "</span>" : "") + "</span>" +
            '<span class="m-vf__cat-go" aria-hidden="true">&rsaquo;</span></a>'
        )
        .join("");
      this.result.innerHTML =
        '<div class="m-vf__result-head"><span class="m-vf__check" aria-hidden="true">✓</span>' +
        "<span>" + this._esc(this.t.forLabel) + " <b>" + y + " " + this._esc(b) + " " + this._esc(m) + "</b></span></div>" +
        '<div class="m-vf__cards">' + cards + "</div>";
      this.result.hidden = false;
    }

    _esc(s) {
      return String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
    }
  }
  customElements.define("m-vehicle-finder", MVehicleFinder);
}
